// globals in brunch config
global.jQuery = require("jquery");
global.$ = global.jQuery;
global.URI = require("urijs"); //build/parse URIs correctly
global.moment = require("moment"); //date library
global.ko = require("knockout"); //templating?
global.Cookies = require("js-cookie"); //adds Cookies.get/Cookies.set

require('jquery-ui/ui/widget');
require('jquery-ui/ui/position');
require('jquery-ui/ui/effect');
require('jquery-ui/ui/effects/effect-highlight');
require('jquery-ui/ui/data');
require('jquery-ui/ui/disable-selection');
require('jquery-ui/ui/focusable');
require('jquery-ui/ui/form');
require('jquery-ui/ui/form-reset-mixin');
require('jquery-ui/ui/keycode');
require('jquery-ui/ui/labels');
require('jquery-ui/ui/scroll-parent');
require('jquery-ui/ui/tabbable');
require('jquery-ui/ui/unique-id');
require('jquery-ui/ui/version');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/resizable');
require('jquery-ui/ui/widgets/accordion');
require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/ui/widgets/button');
require('jquery-ui/ui/widgets/checkboxradio');
require('jquery-ui/ui/widgets/controlgroup');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/dialog');
require('jquery-ui/ui/widgets/menu');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui/ui/widgets/progressbar');
require('jquery-ui/ui/widgets/selectmenu');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui/ui/widgets/spinner');
require('jquery-ui/ui/widgets/tabs');
require('jquery-ui/ui/widgets/tooltip');

require('datejs'); //extend built-in date object

require("jquery.scrollintoview"); //adds $.fn.scrollintoview
require("tablesorter/dist/js/extras/jquery.metadata.min.js");
require("tablesorter"); // $.fn.tablesorter
require("chosen-js"); // $.fn.chosen

require("jquery-autotab"); //$.fn.autotab
require("./jquery.caret.js"); //$.fn.caret

require("./jquery.details.js"); // $.fn.details
require("../ScriptsTS/TimeMask.ts"); // $.fn.timeMask
require("../ScriptsTS/Utilities.ts"); // Ahb.Utilities
require("./MapUtilities.js"); // Ahb.MapUtilities
require("../ScriptsTS/dateeditorhookup.ts"); // $.fn.attachDatePickers
require("./bootstrap-dropdown.js"); //determine if actually used in our code $(elem).dropdown
require("../ScriptsTS/AhbHelper.ts"); // $.fn.currencyInput (plus others)
require("./jquery.multiselect.js"); // $.fn.multiselect; upgrade to npm jquery-ui-multiselect-widget@2.0.1
require("../ScriptsTS/ValidationMethods.ts"); // $.validator.methods.digitsOrSpaces
require("../ScriptsTS/AhbCommentsEditor.ts"); // $.fn.ahbCommentsEditor
require("./filtering.js"); // $.fn.filterDropDown
require("./sortDropDown.js"); // $.fn.sortDropDown
require("../ScriptsTS/AhbDateDifferenceWarning.ts"); // $.fn.triggerDateDifferenceWarningCheck
require("../ScriptsTS/AhbTesterAccreditation.ts"); // $.fn.triggerTesterAccreditationCheck


require("slickgrid-6pac"); // Slick
require("slickgrid-6pac/slick.grid.js"); // Slick.Grid
// apparently not used anywhere!
//    "Placeholders.js": "https://github.com/jamesallardice/Placeholders.js#v4.0.1",
//    "ms-Dropdown": "https://github.com/marghoobsuleman/ms-Dropdown",



//////////////////
// WEBPACK FOOTER
// ./Scripts/app_entry.js
// module id = 350
// module chunks = 0